import React from "react";
import { Controller } from "react-hook-form";
import { IonLabel, IonItem, IonTextarea } from "@ionic/react";
import SkeltonItemContent from "./SkeltonItemContent";

const TextAreaItem = (props) => {
  const {
    name,
    control,
    rules,
    label,
    disabled,
    type,
    loading,
    rows,
    readonly,
    autoGrow,
  } = props;
  return loading ? (
    <IonItem>
      <SkeltonItemContent />
    </IonItem>
  ) : (
    <IonItem>
      <IonLabel position="floating">{label}</IonLabel>
      <Controller
        control={control}
        rules={rules}
        render={({ field }) => {
          const { onChange, onBlur, value } = field;
          return (
            <IonTextarea
              value={value}
              onIonChange={(e) => onChange(e.detail.value)}
              onBlur={onBlur}
              disabled={disabled}
              readonly={readonly}
              type={type}
              rows={rows}
              autoGrow={autoGrow}
            />
          );
        }}
        name={name}
      />
    </IonItem>
  );
};

export default TextAreaItem;
